"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeMultiSelectDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _utils = require("./utils");
var _TypeDisplayWithHydration = require("./TypeDisplayWithHydration");
var _TypeDisplay = require("./TypeDisplay");
var _useSelectedOption = require("../../utils/hooks/useSelectedOption");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _featureFlags = require("../../utils/featureFlags");
var _DropdownUtils = require("../../utils/components/DropdownUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TypeMultiSelectDropdown = _ref => {
  let {
    onChange,
    selectedTypeIds,
    container,
    disabled,
    ...props
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch3);
  const groupedTypes = (0, _hooks.useSelector)(_issueTypes.getAllGroupedTypes);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const groupedOptions = (0, _react.useMemo)(() => (0, _utils.getGroupedTypesAsOptions)(groupedTypes), [groupedTypes]);
  const selectedTypeOptions = (0, _useSelectedOption.useSelectedOptions)(selectedTypeIds, groupedOptions);
  const optionRenderer = (0, _react.useCallback)(props => {
    return /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
      stampCode: props.stampCode,
      title: props.label
    });
  }, []);
  const valueControlDisplay = (0, _react.useCallback)(selectedAmount => selectedAmount === 1 ? /*#__PURE__*/_react.default.createElement(_TypeDisplayWithHydration.TypeDisplayWithHydration, {
    typeId: selectedTypeIds[0]
  }) : T.translate("multiSelect.selectedCount", {
    numSelected: selectedAmount
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedTypeIds]);
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.GroupedSelectBoxWrapper, _extends({
    disabled: disabled,
    multiple: true,
    placeholder: T.translate("filterPanel.typePlaceholder"),
    valueRenderer: () => valueControlDisplay(selectedTypeOptions.length),
    value: selectedTypeOptions,
    options: groupedOptions,
    optionRenderer: optionRenderer,
    onChange: selectedOptions => {
      onChange(selectedOptions !== null ? selectedOptions.map(_ref2 => {
        let {
          value
        } = _ref2;
        return value;
      }) : []);
    },
    clearable: true,
    searchable: true,
    container: container
  }, props));
  const groupedItems = (0, _react.useMemo)(() => {
    // TODO: remove when component migration is finalized
    groupedOptions.forEach(group => group.items = group.options);
    return groupedOptions;
  }, [groupedOptions]);
  const optionMap = (0, _react.useMemo)(() => groupedItems.reduce((map, group) => {
    group.items.forEach(type => map.set(type.value, type));
    return map;
  }, new Map()),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [groupedItems]);
  const getSelectedItems = () => {
    if (!Array.isArray(selectedTypeOptions) || selectedTypeOptions.length < 1) {
      return [];
    }
    // new dropdown requires referential equality for the selected item
    const selectedItems = selectedTypeOptions.reduce((selectedTypes, type) => {
      const selection = optionMap.get(type.value);
      if (selection) {
        selectedTypes.push(selection);
      }
      return selectedTypes;
    }, new Array());
    return selectedItems;
  };
  const selected = getSelectedItems();
  const semanticIdentifier = "type-multi-select-dropdown";
  const NewDropdown = () => {
    const {
      controlProps,
      menuProps
    } = (0, _alloyReactDropdown.useMultiAutocomplete)({
      // TODO: make items property required, remove options property when migration is finalized
      groupedItems: groupedItems,
      selectedItems: selected,
      onSelectedItemsChange: _ref3 => {
        let {
          selectedItems
        } = _ref3;
        return onChange(!!selectedItems ? selectedItems.map(_ref4 => {
          let {
            value
          } = _ref4;
          return value;
        }) : []);
      },
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteControl, _extends({}, controlProps, {
      placeholder: T.translate("filterPanel.typePlaceholder"),
      style: {
        maxHeight: 340
      },
      selectedItem: selected[0],
      renderItem: _ref5 => {
        let {
          isOpen
        } = _ref5;
        return isOpen ? null : valueControlDisplay(
        // only a single token is displayed in the control (as per UX spec) despite this being a multi select
        selected.length);
      },
      "data-testid": "".concat(semanticIdentifier, "-control")
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteMenu, _extends({}, menuProps, {
      renderFooter: () => (0, _DropdownUtils.DropdownFooter)({
        isClearable: true,
        handleChange: () => {
          // work around alloy bug where selectedItem is not updated when clearing
          menuProps.selectItem(null);
          controlProps.selectItem(null);
          onChange([]);
        },
        shouldDisplay: Array.isArray(selected) && selected.length > 0
      }),
      "data-testid": "".concat(semanticIdentifier, "-menu")
    }), menuProps.menuItems.map((itemOrGroupHeader, i) => (0, _alloyReactDropdown.isGroupHeader)(itemOrGroupHeader) ? /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuGroupHeader, {
      key: i,
      "data-testid": "".concat(semanticIdentifier, "-header-").concat(i)
    }, itemOrGroupHeader.label) : /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({
      key: i
    }, menuProps.getItemProps({
      item: itemOrGroupHeader
    }), {
      text: null,
      renderLeftComponent: () => /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
        stampCode: itemOrGroupHeader.stampCode,
        title: itemOrGroupHeader.label
      })
    })))));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.TypeMultiSelectDropdown = TypeMultiSelectDropdown;
//# sourceMappingURL=TypeMultiSelectDropdown.js.map